/* IMPERIUM UGC video strip under Add to cart (Hassan, 2026-09-27; modelled on gohaus.com, no app).
   Speed: cards render posters only; a card's small 480p mp4 is attached and played (muted, looped) only while it is
   on screen; the 720p file with sound loads only when the shopper taps. Markup is generated by build.py. */
(() => {
  if (customElements.get('imp-ugc')) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  // no autoplay previews on Data Saver or slow connections — posters only, tap still plays
  const conn = navigator.connection || {};
  const lowData = conn.saveData || /(^|-)2g|3g/.test(conn.effectiveType || '');
  const PREVIEW_S = 7; // previews loop the first 7s only, so only that much is downloaded

  class ImpUgc extends HTMLElement {
    connectedCallback() {
      this.cards = [...this.querySelectorAll('.imp-ugc__card')];
      this.track = this.querySelector('.imp-ugc__track');
      this.querySelector('[data-ugc-prev]')?.addEventListener('click', () => this.scrollBy(-1));
      this.querySelector('[data-ugc-next]')?.addEventListener('click', () => this.scrollBy(1));
      this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      this.updateArrows();
      if (!reduce && !lowData && 'IntersectionObserver' in window) {
        this.cards.forEach((c) => { const v = c.querySelector('video'); v.addEventListener('timeupdate', () => { if (v.currentTime > PREVIEW_S) v.currentTime = 0; }); });
        const io = new IntersectionObserver((entries) => entries.forEach((e) => {
          const v = e.target.querySelector('video');
          if (e.isIntersecting && e.intersectionRatio > 0.6) {
            if (!v.src) v.src = v.dataset.src;
            v.play().catch(() => {});
          } else if (v.src) v.pause();
        }), { threshold: [0, 0.6] });
        this.cards.forEach((c) => io.observe(c));
      }
      this.cards.forEach((c, i) => c.addEventListener('click', () => this.open(i)));
      this.dialog = this.querySelector('dialog');
      this.player = this.dialog.querySelector('video');
      this.dialog.querySelector('[data-ugc-close]').addEventListener('click', () => this.close());
      this.dialog.querySelector('[data-ugc-dprev]').addEventListener('click', () => this.open(this.i - 1));
      this.dialog.querySelector('[data-ugc-dnext]').addEventListener('click', () => this.open(this.i + 1));
      this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.close(); });
      this.dialog.addEventListener('close', () => {
        this.player.pause(); this.player.removeAttribute('src'); this.player.load();
        document.documentElement.style.overflow = ''; // unlock page scroll (iOS scrolls behind a modal dialog)
      });
      // swipe left/right in the player to change video
      let sx = null;
      this.dialog.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
      this.dialog.addEventListener('touchend', (e) => {
        if (sx === null) return; const dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) > 50 && this.cards.length > 1) this.open(this.i + (dx < 0 ? 1 : -1));
      }, { passive: true });
      this.dialog.querySelector('[data-ugc-shop]').addEventListener('click', () => {
        this.close();
        const target = document.querySelector('.mv-variant-picker') || document.querySelector('product-form, form[action*="/cart/add"]');
        target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
    scrollBy(dir) { this.track.scrollBy({ left: dir * this.track.clientWidth * 0.8, behavior: 'smooth' }); }
    updateArrows() {
      const t = this.track, max = t.scrollWidth - t.clientWidth - 4;
      this.toggleAttribute('data-can-prev', t.scrollLeft > 4);
      this.toggleAttribute('data-can-next', t.scrollLeft < max);
    }
    open(i) {
      const n = this.cards.length; this.i = (i + n) % n;
      const c = this.cards[this.i];
      this.player.poster = c.dataset.poster;
      this.player.src = c.dataset.lg;
      this.player.muted = false;
      this.dialog.querySelector('[data-ugc-caption]').textContent = c.dataset.caption;
      this.dialog.querySelector('[data-ugc-count]').textContent = `${this.i + 1} / ${n}`;
      // AI-made ads (no data-real on the card) carry no "Real IMPERIUM customer" label (Hassan, 2026-10-07)
      this.dialog.querySelector('[data-ugc-label]').textContent = c.dataset.real ? 'Real IMPERIUM customer · ' : '';
      this.dialog.toggleAttribute('data-single', n < 2);
      if (!this.dialog.open) { this.dialog.showModal(); document.documentElement.style.overflow = 'hidden'; }
      this.player.play().catch(() => {});
    }
    close() { if (this.dialog.open) this.dialog.close(); }
  }
  customElements.define('imp-ugc', ImpUgc);
})();
